module.exports = __webpack_public_path__ + "static/img/find_team_icon.390a76c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/find_team_icon.png
// module id = NpO8
// module chunks = 1